import React from 'react';
import Markdown from 'markdown-to-jsx';

import { ClickText, ErrorText, FlexDiv, GenericDiv, GenericP, GenericSpan } from 'common/Styles';
import { DocumentContainer, MainWrapper, PageContainer } from './styles';
import Loader from 'common/Loader/Loader';
import { CheckBoxInput, InputBox, SelectBox } from 'common/FormField/formField';
import Button from 'common/Button/Button';
import { PATHS } from 'AppConstants';

const categoryField = {
	placeholder: 'Select Category',
	label: 'Category',
	value: { label: 'Policy', value: 'POLICY' },
	options: [
		{ label: 'Policy', value: 'POLICY' },
		{ label: 'BOOKING', value: 'BOOKING' },
		{ label: 'REPORTING', value: 'REPORTING' },
		{ label: 'INVOICE', value: 'INVOICE' },
		{ label: 'EXPENSE', value: 'EXPENSE' },
		{ label: 'ONBOARDING', value: 'ONBOARDING' },
		{ label: 'COMMON', value: 'COMMON' }

	]
};

const ocrField = {
	placeholder: 'if ',
	label: 'OCR required',
	options: [
		{ label: 'ocr' }

	]
};

const cleanLlmField = {
	label: 'llm clean required',
	options: [
		{ label: 'clean_llm' }

	]
};

const faqsField = {
	label: 'FAQS',
	options: [
		{ label: 'faqs' }

	]
};

const documentTags = {
	placeholder: 'Keywords',
	label: 'Document Tags',
	type: 'text'
};

const fileUpload = {
	type: 'file',
	name: 'fileupload'
};

const SubCategoryField = {
	placeholder: 'Select Sub Category',
	label: 'Sub Category',
	value: { label: 'FLIGHT', value: 'FLIGHT' },
	options: [
		{ label: 'FLIGHT', value: 'FLIGHT' },
		{ label: 'HOTEL', value: 'HOTEL' },
		{ label: 'BUS', value: 'BUS' },
		{ label: 'TRAIN', value: 'TRAIN' },
		{ label: 'CABS', value: 'CABS' },
		{ label: 'REQUISITION', value: 'REQUISITION' },
		{ label: 'NONE', value: '' }

	]
};

const List = () => {
	const [documentsList, setDocumentsList] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [categories_map, setcategories_map] = React.useState(null);
	const [delLoading, setDelLoading] = React.useState(false);
	const [upldLoading, setUpldoading] = React.useState(false);
	const [error, setError] = React.useState(null);
	const [selectedDocument, setSelectedDocument] = React.useState(null);
	const [showDocument, setShowDocument] = React.useState(false);
	const [fileNames, setFileNames] = React.useState([]);
	console.log('fileNames', selectedDocument);

	const fetchDocuments = async () => {
		setLoading(true);
		try {
			const response = await fetch(PATHS.CCB_URL + '/llm/get-all-docs');
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const data = await response.json();
			/** sample data structure
				const data = {
					 "categories_map": {
        "POLICY": {
            "FLIGHT": [
                "domestic_flight_policy.pdf",
                "international_flight_policy.pdf"
            ],
            "BUS": [
                "bus_policy_setup.pdf"
            ]
        }
    },
					"files":{
						"ids": ["asd12312asd"],
						"content":{
							"page_no":"text content"
						}
					}
				}
				 **/
			// get the filenmae from the data in array
			setFileNames(Object.keys(data));
			setcategories_map(data.categories_map);
			setDocumentsList(data.files);
		} catch (error) {
			setError(error);
		} finally {
			setLoading(false);
		}
	};

	const deleteDocument = async (document) => {
		setDelLoading(true);
		try {
			const response = await fetch(PATHS.CCB_URL + '/llm/delete-doc', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ filename: document, category: documentsList[document]['collection_name'] })
			});
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const data = await response.json();
			if (data.status === 'success') {
				fetchDocuments();
			}
		} catch (error) {
			setError(error);
		} finally {
			setDelLoading(false);
		}
	};
	React.useEffect(() => {
		fetchDocuments();
	}, []);
	const handleDocumentClick = (document) => {
		setSelectedDocument(selectedDocument === document ? false : document);
		setShowDocument(selectedDocument !== document );
	};

	const handleChange = (e) => {
		if (e.target?.name === 'fileupload') {
			setError(false);
			fileUpload.value = e.target.files[0];
		}
	};

	const handleUpload = async (e) => {
		e.preventDefault();
		const formData = new FormData();
		if (!fileUpload.value) {
			setError({ message: 'Please select a file to upload' });
			return;
		}
		formData.append('file', fileUpload.value);
		formData.append('category', categoryField.value.value);
		formData.append('subcategory', SubCategoryField.value.value);
		formData.append('additional_info', documentTags.value);
		formData.append('isOcr', ocrField.value || false);
		formData.append('isFaqs', faqsField.value || false);
		formData.append('isCleanText', !!cleanLlmField.value);
		setUpldoading(true);
		try {
			const res = await fetch(PATHS.CCB_URL + '/llm/process-pdf', {
				method: 'POST',
				body: formData
			});
			if (!res.ok) {
				throw new Error('Upload failed');
			}
			const data = await res.json();
			console.log(data);
			if (data.cleaned_data) {
				fetchDocuments();
			}
		} catch (err) {
			console.error('Upload error:', err);
		} finally {
			setUpldoading(false);
		}
	};
	console.log(categories_map);
	return (
		<MainWrapper top_M='30' $direction='column' justify='flex-start'>
			{loading && <Loader size='15' color='#723b63' />}
			{error && <ErrorText>Error: {error.message}</ErrorText>}
			<h2>Upload new document</h2>
			<FlexDiv bottom_M='50' wrap='wrap' onSubmit={handleUpload} align='center' as='form' top_P='20' direction='column' justify='space-between'>
				<input name={fileUpload.name} type={fileUpload.type} onChange={handleChange} />
				<SelectBox width='250px' onChange={handleChange} field={categoryField} />
				<SelectBox width='250px' onChange={handleChange} field={SubCategoryField} />
				<InputBox width='250px' handleChange={handleChange} field={documentTags} />
				<FlexDiv justify='flex-start'>
					<CheckBoxInput field={ocrField} />
					<CheckBoxInput field={cleanLlmField} />
					<CheckBoxInput field={faqsField} />
				</FlexDiv>
				<Button
					btnWidth='150px'
					type='submit'
					disabled={upldLoading}
					disableClass='disabledwithLoader'
					btnTxt={upldLoading ? <Loader margin='0' color='#fff' size='10' /> : 'UPLOAD'}
				/>
			</FlexDiv>
			<h2>Documents List</h2>
			{fileNames.length === 0 && !loading && <GenericP fsize='18px' f_weight='900'>No documents available</GenericP>}
			<FlexDiv top_P='20' $direction='column' justify='flex-start'>
				{categories_map && Object.keys(categories_map).map((category) => (
					<GenericDiv key={category} bottom_P='10' left_P='15'>
						<GenericP fsize='18px' f_weight='900'>{category}</GenericP>
						{Object.keys(categories_map[category]).map((subCategory) => (
							<GenericDiv top_M='10' key={subCategory} bottom_P='10' left_P='15'>
								<GenericP fsize='16px' f_weight='700'>{subCategory}</GenericP>
								{categories_map[category][subCategory].map((document, i) => (
									<GenericDiv bottom_P='10' color='#777777' left_P='15' key={document}>
										{i + 1}. <GenericSpan right_M='20' fsize='16px' color='#777777' $cursor='pointer'>{document}</GenericSpan>
										<ClickText onClick={() => handleDocumentClick(document)}>{selectedDocument === document ? 'Close' : 'Show'} Document</ClickText> | <ClickText onClick={() => deleteDocument(document)}>{!delLoading ? 'Delete' : <Loader display='inline-block' size='6' color='#723b63' />}</ClickText>

										{showDocument && selectedDocument == document && (
										<DocumentContainer direction='column' color='#000' $width='800px' margin='15px 20px 20px' borderRadius='5'>
											{documentsList[selectedDocument].content.map((content, index) => (
												<PageContainer
													key={index}
													padding='20px' margin='5px 20px 10px' boxShadow='0 2px 4px rgba(0, 0, 0, 0.1),
												0 4px 8px rgba(0, 0, 0, 0.15),
												0 8px 16px rgba(0, 0, 0, 0.2);'>
													<Markdown>{content.content}</Markdown>
													<GenericP top_M='20' text_align='center' f_weight='700'>Page {index + 1}</GenericP>
												</PageContainer>))}
										</DocumentContainer>
										)}
									</GenericDiv>
								))}
							</GenericDiv>
						))}
					</GenericDiv>
				))}
			</FlexDiv>
		</MainWrapper>
	);
};
export default List;
